export const FETCH_KKM = 'kkmPage/FETCH_KKM';
export const UPDATE_KKM = 'kkm/UPDATE';
